module.exports = __webpack_public_path__ + "static/media/sendToBack.813dea15.svg";